import * as actionTypes from "../actions/actionTypes";
import * as actionHandler from "../actions/userActions";

const initialState = {
  id: null,
  name: ""
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_USER:
      return actionHandler.updateUser(state, action);
    case actionTypes.RESET_APP:
      return actionHandler.resetUser(state, action);
    default:
      return state;
  }
};

export default reducer;
